import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IActiveShifts } from '../../models/dashboard/jobs/getActiveShifts.model';

interface IJobApplicationQuery {
  jobData: IActiveShifts[];
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
}

const initialState: IJobApplicationQuery = {
  jobData: [],
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
};

const activeJobApplicationsSlice = createSlice({
  name: 'jobApplications',
  initialState,
  reducers: {
    activeJobApplications(state, action: PayloadAction<IJobApplicationQuery>) {
      return { ...state, ...action.payload };
    },
  },
});

export const activeJobApplicationsActions = activeJobApplicationsSlice.actions;
export default activeJobApplicationsSlice.reducer;
